import { generateID } from "./helpers.js";

export default class HistoryNode {

	constructor({ parentNode, timestamp, operation, name, id }) {
		this.parentNode = parentNode;
		this.childNodes = [];
		this.timestamp = timestamp ?? Date.now();
		this.operation = operation;
		this.name = name;
		this.id = id ?? generateID();
	}
}
